// Copyright (c) 2024 Deere & Company

import actions from '../../actions-list';
import {getDefaultState as getWipDefaultState} from '../state';

const updateAmountOfUseLength = (state, action) => action.length;

export default (state = getWipDefaultState().amountOfUseLength, action) => {

    const actionTypes = {
        [actions.UPDATE_TCSM_AMOUNT_OF_USE_LENGTH]: updateAmountOfUseLength
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/wip/reducers/amount-of-use-length.js